import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtDate, ageLabel } from "@/lib/fers";
import { footerAndSave } from "@/lib/checklistPdf";
import { usd } from "@/lib/format";
import { incomeLines, toDate, daysUntil } from "@/lib/snapshot";

export function exportSnapshotPdf(d, firstName) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const lines = incomeLines(d);
  doc.setFont("helvetica", "bold").setFontSize(20).setTextColor(15, 23, 42).text(`${firstName ? `${firstName}'s` : "My"} Retirement Snapshot`, 40, 56);
  doc.setFont("helvetica", "normal").setFontSize(10).setTextColor(90).text(`${d.system}  |  Retiring at ${ageLabel(d.retire_age)}  |  Generated ${fmtDate(new Date())}`, 40, 76);
  doc.setFontSize(12).setTextColor(20).text(`Retirement day: ${fmtDate(toDate(d.retirement_date))}  (${daysUntil(d.retirement_date).toLocaleString()} days to go)`, 40, 104);
  doc.text(`Current TSP balance: ${usd(d.tsp_balance)}`, 40, 122);
  if (d.next_milestone) doc.text(`Next milestone: ${d.next_milestone.label} on ${fmtDate(toDate(d.next_milestone.date))}`, 40, 140);
  autoTable(doc, {
    startY: 160,
    head: [["Projected monthly income (before tax)", "Amount", "Details"]],
    body: [...lines.map((l) => [l.label, usd(l.value), l.note]),
      ["First-year total", usd(d.first_year_monthly), "All sources paid in year one"],
      ["Once all income starts", usd(d.full_monthly), `From age ${ageLabel(d.full_age)}`]],
    styles: { fontSize: 10, cellPadding: 7, lineColor: [226, 232, 240], lineWidth: 0.5 },
    headStyles: { fillColor: [15, 23, 42], textColor: 255 },
    didParseCell: (c) => { if (c.section === "body" && c.row.index >= lines.length) c.cell.styles.fontStyle = "bold"; },
    margin: { left: 40, right: 40 },
  });
  const note = `Plan: ${d.plan_label}. Amounts are estimates in future dollars from the owner's PillarWealth profile and assumptions; they are not an official OPM, SSA or TSP statement.`;
  doc.setFontSize(9).setTextColor(100).text(doc.splitTextToSize(note, 530), 40, doc.lastAutoTable.finalY + 24);
  return footerAndSave(doc, "retirement-snapshot", "Estimates only, not financial advice");
}
